import React from 'react';
import "../sass/components/select.scss";

const Select = (props) => {
    return (
        <div className={"c-select"}>
            {props.label ?
                <label>
                    {props.label}
                </label> : null
            }
            <div className="c-select__input">
                <select
                    id={props.id}
                    onChange={props.onChange}
                    defaultValue={props.selected}
                    disabled={props.disabled}
                >
                    {props.options.map((option, index) => (
                        <option key={index} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <span className="c-select__arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M319 207L224 302.1L128.1 207c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l112 112C211.7 357.7 217.8 360 224 360s12.28-2.344 16.97-7.031l112-112c9.375-9.375 9.375-24.56 0-33.94S328.4 197.7 319 207zM384 32H64C28.65 32 0 60.66 0 96v320c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64V96C448 60.66 419.3 32 384 32zM400 416c0 8.82-7.178 16-16 16H64c-8.822 0-16-7.18-16-16V96c0-8.82 7.178-16 16-16h320c8.822 0 16 7.18 16 16V416z"/></svg>
                </span>
            </div>
        </div>
    );
};

export default Select;
